import {Directive, ElementRef, Inject, Input, OnDestroy, OnInit} from '@angular/core';
import * as Inputmask from 'inputmask';
import {NgControl} from '@angular/forms';

/**
 * Инициализация маски ввода на элементе
 * https://github.com/RobinHerbots/Inputmask
 */
@Directive({
    selector: 'input[appInputmask]',
})
export class InputmaskDirective implements OnInit, OnDestroy {
    @Input() appInputmask: string;
    @Input() inputmaskPlaceholder = '_';

    private native: HTMLInputElement;

    constructor(
        private _elementRef: ElementRef,
        private control: NgControl,
        @Inject('INPUTMASK_GLOSSARY') private glossary: object
    ) {
        this.native = this._elementRef.nativeElement;
    }

    ngOnInit() {
        if (!this.appInputmask) {
            return;
        }

        /**
         * Берем маску из словаря, если вдруг нам пришел подходящий ключ маски, вместо значения
         * @type {string}
         */
        let mask = this.appInputmask;
        let im;

        if (mask === 'count') {
            /**
             * Маска количества будет числовой на 4 челых и 2 дробных числа.
             * @TODO Когда-нибудь обновиться, чтобы запятая могла преобразовываться в точку.
             * https://github.com/RobinHerbots/Inputmask/issues/1634
             * https://github.com/RobinHerbots/Inputmask/issues/919
             */
            im = new Inputmask('decimal', {
                rightAlign: false,
                radixPoint: '.',
                integerDigits: 4,
                digitsOptional: true,
                digits: 2,
                allowMinus: false,
                greedy: false,
                undoOnEscape: false
            });
        } else {
            if (this.glossary.hasOwnProperty(mask)) {
                mask = this.glossary[mask];
            }

            im = new Inputmask(mask, {
                placeholder : this.inputmaskPlaceholder,
                greedy: false,
                undoOnEscape: false,
                definitions: {
                    /**
                     * Символ-маска для ввода произвольного номера телефона.
                     * Разрешены только цифры, пробелы, скобки и тире
                     */
                    '✆': {
                        validator: '[0-9\\\ \\\-\\\(\\\)]',
                        cardinality: 1
                    }
                }
            });
        }

        im.mask(this.native);

        /**
         * Полученно после маски ввода значение применяем к полю формы, чтобы оно провалидировалось заново.
         * Это на случай, если после ввода маски для поля у нас в БД есть старое значение, которое не совпадает с маской.
         */
        const oldValue = this.control.control.value;
        const maskedValue = this.native.value;
        if (oldValue !== maskedValue) {
            this.control.control.patchValue(maskedValue);
            this.control.control.updateValueAndValidity();
        }
    }

    ngOnDestroy() {

    }
}
